import allCitiesJson from '@r1-frontend/geo/data/allCities.json';

const allDomains = allCitiesJson.map(city => city.domain);

export const getCityFromHostName = (hostname?: string): string => {
    if (!hostname) {
        return '';
    }

    const [cityDomain] = hostname.split('.');
    return allDomains.find(domain => cityDomain === domain) || '';
};
